declare var BIS: any;

export function sampleFormBackInStockListener() {
  const emailInput = document.getElementById('notify_email') as HTMLInputElement | null;
  const notifyButton = document.getElementById('notify_button') as HTMLButtonElement | null;
  const marketingCheckbox = document.getElementById('accepts_marketing') as HTMLInputElement | null;

  if (!emailInput || !notifyButton || !marketingCheckbox) {
    return;
  }

  // Regular expression for basic email validation
  const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

  function validateForm() {
    if (notifyButton && emailInput && marketingCheckbox) {
      notifyButton.disabled = !emailRegex.test(emailInput.value) || !marketingCheckbox.checked;
    }
  }

  emailInput.addEventListener('input', validateForm);
  marketingCheckbox.addEventListener('change', validateForm);

  interface NotificationData {
    status: 'OK' | 'Error';
    errors?: {
      [key: string]: string;
    };
  }

  const notificationCallback = (data: NotificationData) => {
    let msg = '';
    if (data.status === 'OK') {
      window.notificationsManager.open({
        type: window.notificationsManager.types.NOTIFICATION_SUCCESS,
        body: 'Your notification has been registered.'
      });
    } else if (data.errors) {
      for (const key in data.errors) {
        if (data.errors.hasOwnProperty(key)) {
          msg += `${data.errors[key]}`;
        }
      }
      window.notificationsManager.open({
        type: window.notificationsManager.types.NOTIFICATION_ERROR,
        body: msg
      });
    }
  };

  notifyButton?.addEventListener('click', function (e) {
    e.preventDefault();
    if (!emailInput) return;

    const email = emailInput.value;
    const productId = this.dataset.productId;
    const variantId = this.dataset.variantId;
    const options = {
      accepts_marketing: marketingCheckbox.checked,
      quantity_required: 1
    };

    BIS.create(email, variantId, productId, options)
      .then(notificationCallback);
  });
}
